import { Navigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";

export const homeFor = (user) => (user?.role === "borrower" ? "/portal" : "/");

export default function ProtectedRoute({ children, role = "admin" }) {
  const { user, loading } = useAuth();
  if (loading)
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0B0F17] text-emerald-400 font-mono">
        Loading…
      </div>
    );
  if (!user) return <Navigate to="/login" replace />;
  if (user.role !== role) return <Navigate to={homeFor(user)} replace />;
  return children;
}
